module.exports = __webpack_public_path__ + "media/img/virtual-internships/student-testimonial-elizabeth-cone-2656e0a57bb6b51e0584716819f7b639.png";